/** News topics are shared project-wide; the seller prefix prevents app collisions. */
export function sellerNewsTopics(roles: readonly string[], subdivision: string): string[] {
  if (!roles.some((role) => role.toLowerCase() === 'seller')) return []
  const topics = ['seller-news-all']
  const id = subdivision.trim().toLowerCase()
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(id)) {
    topics.push(`seller-news-${id}`)
  }
  return topics
}
